import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a1929] text-white relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10 pt-20 pb-10 relative">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <div className="mb-6">
              <img src="/logo.jpg" alt="GIGA CLEAN SERVICE" className="h-14 rounded-xl shadow-lg shadow-black/30" />
            </div>
            <p className="text-sm text-white/70 max-w-sm leading-relaxed">
              Votre partenaire de confiance en nettoyage professionnel en Île-de-France.
              Bureaux, commerces, chantiers — nous prenons soin de vos espaces.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" aria-label="Facebook" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#2196F3] flex items-center justify-center transition-colors" data-testid="footer-facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" aria-label="LinkedIn" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#2196F3] flex items-center justify-center transition-colors" data-testid="footer-linkedin">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" aria-label="Instagram" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#2196F3] flex items-center justify-center transition-colors" data-testid="footer-instagram">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-[#64B5F6]">Navigation</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/" className="hover:text-white">Accueil</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/a-propos" className="hover:text-white">À propos</Link></li>
              <li><Link to="/references" className="hover:text-white">Références</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-[#64B5F6]">Services</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li>Nettoyage de bureaux</li>
              <li>Locaux commerciaux</li>
              <li>Après travaux</li>
              <li>Vitrerie</li>
              <li>Remise en état</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-[#64B5F6]">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-[#64B5F6]" />
                <span>RN370 Espace Godard<br />Gonesse 95500</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0 text-[#64B5F6]" />
                <a href="mailto:gigacleanservice@outlook.fr" className="hover:text-white break-all">gigacleanservice@outlook.fr</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} GIGA CLEAN SERVICE — Sindou Kamagate, Directeur. Tous droits réservés.</div>
          <div>Nettoyage professionnel — Île-de-France</div>
        </div>
      </div>
      <div aria-hidden className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#2196F3]/30 blur-3xl" />
    </footer>
  );
}
